const tutorials = [
  {
    path: '/tutoriais',
    name: 'tutorials.index',
    component: () => import('@/views/tutorials/TutorialsIndex.vue'),
    meta: {
      need_capability: 'dashboard',
      roles: [1, 2, 5, 6],
      pageTitle: 'Tutoriais',
      breadcrumb: [
        {
          text: 'Tutoriais',
          active: true,
        },
      ],
    },
  },
  {
    path: '/tutoriais/:id',
    name: 'tutorials.show',
    component: () => import('@/views/tutorials/TutorialShow.vue'),
    meta: {
      need_capability: 'dashboard',
      roles: [1, 2, 5, 6],
      pageTitle: 'Tutorial',
      breadcrumb: [
        {
          text: 'Tutoriais',
          to: 'tutorials.index',
        },
        {
          text: 'Assistir',
          active: true,
        },
      ],
    },
  },
]

export default tutorials
